export const LINES_TO_CLAMP = 5;
